// Author LiangGangQiang
// Date 2021-08-21 11:38:57

import * as model from "@/model/sithMes/prd/SithMesPrdManBorrowProcessModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdManBorrowProcess(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdManBorrowProcess/workflow/complete-feedback',
        processDefinitionKey: "sith_mes_prd_man_borrow",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
